export const Routes = {
  HOME: 'Home Screen',
  LOGIN: 'Login',
  OUTSIDE_STACK: 'Outside Stack',
  INSIDE_STACK: 'Inside Stack',
  DASHBOARD: 'Dashboard',
  VIEWEMPLOYEE: 'ViewEmployee',
  ADDEMPLOYEE: 'AddEmployee',
  TEAM: 'Team',
  PROJECT: 'Project',
  VIEWPROJECT: 'ViewProject',
  ADDPROJECT: 'AddProject',
  PROJECTDASHBOARD: 'ProjectDashboard',
  PROJECTTEAMMEMBERS: 'ProjectsTeamMembers',
  SETTINGS: 'Settings',
  PROJECT_STATUS: 'Project Status',
  PROJECT_REQUIREMENT: 'Project Requirement',
  TEAM_MANAGEMENT: 'Team Management',
  PROJECT_MANAGEMENT: 'Project Management',
  PROJECT_MANAGEMENT_INDEX: 'Project Management Index',
  VIEW_EMPLOYEE_DETAILS: 'View Employee Details',
  UPDATE_EMPLOYEE_DETAILS: 'Update Employee Details',
  PROJECT_DETAILS: 'Project Details',
  PROJECT_EDIT: 'Project Edit',
  PROJECT_BACKLOGS: 'Project Backlogs',
  ADD_USER_STORY: 'Add UserStory',
  PROJECT_SPRINT: 'Project Sprint',
  PROJECT_TASK: 'Project Task',
  PROJECT_EPIC: 'Project Epic',
  PROJECT_ISSUES: 'Project Issues',
  PROJECT_REPORT: 'Project Report',
  VIEW_USER_STORY: 'View UserStory',
  MY_PROFILE: 'My Profile',
  VIEW_PROFILE: 'View Profile',
  EDIT_PROFILE: 'Edit Profile',
  RESET_PASSWORD: 'Reset Password',
  FORGOT_PASSWORD: 'Forgot Password',
  RESET_PASSWORD_FIRST: 'Reset Password First',
  FORGOT_PASSWORD_PRE_LOGIN: 'Forgot Password Pre login',
  SIGN_UP:'Sign Up',
} as const;

type RouteKeys = keyof typeof Routes;
export type RouteValues = (typeof Routes)[RouteKeys];

export type RootNavigatorParams = {
  [Routes.INSIDE_STACK]: undefined;
  [Routes.OUTSIDE_STACK]: undefined;
  [Routes.HOME]: undefined;
  [Routes.LOGIN]: undefined;
  [Routes.DASHBOARD]: undefined;
  [Routes.PROJECT]: undefined;
  [Routes.SETTINGS]: undefined;
  [Routes.MY_PROFILE]: undefined;
  [Routes.TEAM]: undefined;
  [Routes.VIEWEMPLOYEE]: undefined;
  [Routes.ADDEMPLOYEE]: undefined;
  [Routes.VIEWPROJECT]: undefined;
  [Routes.ADDPROJECT]: undefined;
  [Routes.PROJECTDASHBOARD]: {id: string};
  [Routes.PROJECTTEAMMEMBERS]: {id: string};
  [Routes.PROJECT_STATUS]: {id: string};
  [Routes.PROJECT_REQUIREMENT]: {id: string};
  [Routes.TEAM_MANAGEMENT]: {id: string};
  [Routes.PROJECT_MANAGEMENT]: {id: string};
  [Routes.PROJECT_MANAGEMENT_INDEX]: {id: string};
  [Routes.PROJECT_DETAILS]: {id: string};
  [Routes.PROJECT_EDIT]: {id: string};
  [Routes.PROJECT_BACKLOGS]: {id: string};
  [Routes.ADD_USER_STORY]: {id: string};
  [Routes.VIEW_EMPLOYEE_DETAILS]: {id: string};
  [Routes.UPDATE_EMPLOYEE_DETAILS]: {id: string};
  [Routes.PROJECT_SPRINT]: {id: string};
  [Routes.PROJECT_TASK]: {id: string};
  [Routes.PROJECT_EPIC]: {id: string};
  [Routes.PROJECT_ISSUES]: {id: string};
  [Routes.PROJECT_REPORT]: {id: string};
  [Routes.VIEW_USER_STORY]: {id: string; usid: string};
  [Routes.MY_PROFILE]: undefined;
  [Routes.VIEW_PROFILE]: undefined;
  [Routes.EDIT_PROFILE]: undefined;
  [Routes.RESET_PASSWORD]: undefined;
  [Routes.FORGOT_PASSWORD]: undefined;
  [Routes.RESET_PASSWORD_FIRST]: undefined;
  [Routes.FORGOT_PASSWORD_PRE_LOGIN]: undefined,
  [Routes.SIGN_UP]: undefined,
};

export const screenLinking = {
  [Routes.INSIDE_STACK]: {
    screens: {
      [Routes.RESET_PASSWORD_FIRST]: 'reset-password-first',
      [Routes.DASHBOARD]: 'dashboard',
      [Routes.TEAM]: {
        screens: {
          [Routes.VIEWEMPLOYEE]: 'team',
          [Routes.ADDEMPLOYEE]: 'team/add-employee',
          [Routes.VIEW_EMPLOYEE_DETAILS]: 'team/:id/view',
          [Routes.UPDATE_EMPLOYEE_DETAILS]: 'team/:id/edit',
        },
      },
      [Routes.PROJECT]: {
        screens: {
          [Routes.VIEWPROJECT]: 'projects',
          [Routes.ADDPROJECT]: 'projects/add-project',
          [Routes.PROJECTDASHBOARD]: {
            path: 'project/:id',
            screens: {
              [Routes.PROJECT_STATUS]: 'project-status',
              [Routes.PROJECT_REQUIREMENT]: {
                path: 'project-requirement',
                screens: {
                  [Routes.PROJECT_DETAILS]: 'details',
                  [Routes.PROJECT_EDIT]: 'edit',
                },
              },
              [Routes.PROJECTTEAMMEMBERS]: 'team',
              [Routes.TEAM_MANAGEMENT]: 'team-management',
              [Routes.PROJECT_MANAGEMENT]: {
                path: 'project-management',
                screens: {
                  [Routes.PROJECT_MANAGEMENT_INDEX]: '',
                  [Routes.PROJECT_BACKLOGS]: 'backlogs',
                  [Routes.ADD_USER_STORY]: 'user-story/add',
                  [Routes.VIEW_USER_STORY]: 'user-story/view/:usid',
                  [Routes.PROJECT_SPRINT]: 'sprints',
                  [Routes.PROJECT_TASK]: 'tasks',
                  [Routes.PROJECT_EPIC]: 'epics',
                  [Routes.PROJECT_ISSUES]: 'issues',
                  [Routes.PROJECT_REPORT]: 'report',
                },
              },
            },
          },
        },
      },
      [Routes.MY_PROFILE]: {
        path: 'profile',
        screens: {
          [Routes.VIEW_PROFILE]: 'view',
          [Routes.EDIT_PROFILE]: 'edit',
          [Routes.RESET_PASSWORD]: 'reset-password',
          [Routes.FORGOT_PASSWORD]: 'forgot-password',
        },
      },
      [Routes.SETTINGS]: 'settings',
    },
  },
  [Routes.OUTSIDE_STACK]: {
    screens: {
      [Routes.HOME]: '',
      [Routes.LOGIN]: 'login',
      [Routes.SIGN_UP]: 'signup',
      [Routes.FORGOT_PASSWORD_PRE_LOGIN]: 'forgot-password',
    },
  },
};
